import { getProductColorShade } from '@george-labs.com/design-system';
import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';

import { useGlobalColor } from './GlobalColorContext';

type ColorVariants = {
    color?: COLOR;
    weakColor?: COLOR;
    strongColor?: COLOR;
};

export const useGlobalColorVariants = (): ColorVariants => {
    const { value } = useGlobalColor();

    if (!value) {
        return {};
    }

    return {
        color: value,
        weakColor: getProductColorShade(value, 'weak'),
        strongColor: getProductColorShade(value, 'strong'),
    };
};
